import { render, staticRenderFns } from "./omt-p.vue?vue&type=template&id=ff097cec&scoped=true&"
import script from "./omt-p.vue?vue&type=script&lang=js&"
export * from "./omt-p.vue?vue&type=script&lang=js&"
import style0 from "./omt-p.vue?vue&type=style&index=0&id=ff097cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff097cec",
  null
  
)

export default component.exports